import { render, staticRenderFns } from "./outAllow.vue?vue&type=template&id=6671672c&scoped=true&"
import script from "./outAllow.vue?vue&type=script&lang=js&"
export * from "./outAllow.vue?vue&type=script&lang=js&"
import style0 from "./outAllow.vue?vue&type=style&index=0&id=6671672c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6671672c",
  null
  
)

export default component.exports